import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
// import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';
import Hidden from '@material-ui/core/Hidden';
import useStyles from './styles';

const AuthFooter = () => {
    const classes = useStyles();
    return (

        <Grid container>
            {/* <Grid container item xs={6} md={6} className={classes.privacyContainer}>
                <Button className={classes.bottomButtons}>
                    Política de Privacidade
                </Button>
            </Grid>
            <Grid container item xs={6} md={6} className={classes.termsContainer}>
                <Button className={classes.bottomButtons}>
                    Termos de Uso
                </Button>
            </Grid> */}
            <Hidden smDown>
                <Box className={classes.pepsicoCopyright}>
                    <Typography>
                        © 2026 Pepsico
                    </Typography>
                </Box>
            </Hidden>
        </Grid>
    );
}

export default AuthFooter;